import { render, staticRenderFns } from "./PrintConsentForm.vue?vue&type=template&id=bf1ad856"
import script from "./PrintConsentForm.vue?vue&type=script&lang=js"
export * from "./PrintConsentForm.vue?vue&type=script&lang=js"
import style0 from "./PrintConsentForm.vue?vue&type=style&index=0&id=bf1ad856&prod&lang=scss"
import style1 from "./PrintConsentForm.vue?vue&type=style&index=1&id=bf1ad856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports